export default __webpack_public_path__ + "assets/images/d38711c5542706893776ec2e060b2f04.jpg";